import { toast } from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import { intl } from "i18n/provider";
import React from "react";

const ToastContent = ({ icon, message, mobileNumber, onClose }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
    }}
  >
    <div style={{ display: "flex", alignItems: "center" }}>
      <span style={{ marginLeft: 8 }}>
        {message} ({mobileNumber})
      </span>
    </div>
    <CloseIcon
      onClick={onClose}
      style={{ cursor: "pointer", marginLeft: 16 }}
    />
  </div>
);

export const ShowToastPromise = async (callback, { mobileNumber }) => {
  const toastId = toast.custom(
    (t) => (
      <ToastContent
        message={intl.formatMessage({ id: "your_request_is_in_progress" })}
        mobileNumber={mobileNumber}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    {
      duration: 240000, // 4 minutes in milliseconds
      position: "top-left",
    }
  );
  toast.loading(
    (t) => (
      <ToastContent
        message={intl.formatMessage({ id: "your_request_is_in_progress" })}
        mobileNumber={mobileNumber}
        onClose={() => toast.dismiss(t.id)}
      />
    ),
    { id: toastId }
  );
  try {
    const result = await callback();
    toast.success(
      (t) => (
        <ToastContent
          message={intl.formatMessage({ id: "success_op" })}
          mobileNumber={mobileNumber}
          onClose={() => toast.dismiss(t.id)}
        />
      ),
      { id: toastId }
    );
    return result;
  } catch (error) {
    toast.error(
      (t) => (
        <ToastContent
          message={intl.formatMessage({ id: "failed" })}
          mobileNumber={mobileNumber}
          onClose={() => toast.dismiss(t.id)}
        />
      ),
      { id: toastId }
    );
    throw error;
  }
};
